import React, { useEffect, useState } from "react";
import apiClient from "../../apiClient";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { UNVERIFIED_RESOURCE } from "../../apiClient/apiEndpoints";
import logo from "../../Static/images/logo.png";
import NoDataFound from "../Quiz/NoDataFound/NoDataFound";

const UnPublishedList = ({ searchText, selectedCheckboxes, selectedCategoryCheckboxes }) => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [fetchingLoading, setFetchingLoading] = useState(true);
  const [list, setList] = useState([]);

  const getResourceUnverified = async () => {
    try {
      setFetchingLoading(true);
      let data = await apiClient.get(`${configData.config.UNO_URL}${UNVERIFIED_RESOURCE}/module`);
      data = data.filter((e) => !e?.versions[0]?.data?.publishId);
      setList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setFetchingLoading(false);
    }
  };

  useEffect(() => {
    getResourceUnverified();
  }, []);

  const filterCourses = (e) => {
    if (searchText.length && !e.name.toLowerCase().includes(searchText.toLowerCase())) return false;
    const tags = e.tags.map((e) => e.id);
    const tagCategory = e.tagCategory.map((e) => e.id);
    if (selectedCheckboxes.length && !selectedCheckboxes.every((element) => tags.includes(element.id))) return false;
    if (
      selectedCategoryCheckboxes.length &&
      !selectedCategoryCheckboxes.some((checkbox) => tagCategory.includes(checkbox.id))
    )
      return false;
    return true;
  };

  let filteredList = list.filter(filterCourses);

  return (
    <>
      <div className="lowersection">
        <div className="container-fluid px-4">
          {fetchingLoading ? (
            <div className="modulelist">
              <NoDataFound text="Data is fetching...." />
            </div>
          ) : (
            <>
              {filteredList.length > 0 ? (
                <>
                  <div className="modulelist">
                    <div className="course-tiles">
                      {filteredList?.map((e, index) => {
                        if (searchText.length && !e.name.toLowerCase().includes(searchText.toLowerCase())) return null;

                        return (
                          <div className="tilecard" key={index + 1}>
                            <div
                              className="modulecard module"
                              onClick={() =>
                                navigate(`/dashboard/xr/review/details/${e.uuid}`, {
                                  state: { name: e.name, type: "MODULE", actionMode: "REVIEW" },
                                })
                              }
                            >
                              <div className="moduleicon">
                                {e?.versions[0]?.data?.thumbnail ? (
                                  <img src={e.versions[0].data.thumbnail} alt="Thumbnail" />
                                ) : (
                                  <img src={logo} className="defaultimg" alt="Default Thumbnail" />
                                )}
                              </div>
                              <div className="moduledata">
                                <Tooltip title={e?.name}>
                                  <p className="modulename">{e?.name}</p>
                                </Tooltip>
                                <p className="moduledes">{e?.versions[0]?.data?.short}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : (
                <div className="modulelist">
                  <NoDataFound text="No Data Found" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default UnPublishedList;
